<template>
  <el-dialog title="详情" v-if="visible" :visible.sync="visible" :before-close="handleClose">
    <el-empty v-if="res.code == 500" :description="res.msg"></el-empty>
    <el-descriptions  v-if="res.code == 200" border>
      <el-descriptions-item label="收货人姓名">{{ res.data.consigneeName }}</el-descriptions-item>
      <el-descriptions-item label="收货人联系电话">{{ res.data.consigneePhone }}</el-descriptions-item>
      <el-descriptions-item label="订单编号">{{ res.data.tradeNo }}</el-descriptions-item>
      <el-descriptions-item label="快递单号" v-if="deliverNo">{{ deliverNo }}</el-descriptions-item>
      <el-descriptions-item label="收货地址">{{ res.data.consigneeAddress }}</el-descriptions-item>
    </el-descriptions>
  </el-dialog>
</template>

<script>

export default {
  name: "shippingDetails",
  data(){
    return {
      visible: false,
      tradeNo: '',
      deliverNo: null,
      res: {
        code: ''
      }
    }
  },
  methods:{
    show(visible , tradeNo , deliverNo) {
      this.visible = visible
      this.tradeNo = tradeNo
      this.deliverNo = deliverNo
      this.getConsigneeInfo(this.tradeNo)
    },
    getConsigneeInfo(tradeNo){
      this.$http.post(this.$api.customerEnterprise.getConsigneeInfo, {tradeNo: tradeNo}).then(res => {
        this.res = res.data
      })
    },
    handleClose() {
      this.visible = false;
      this.res = {
        code: ''
      }
      this.$emit('handleQuery')
    }
  }
}
</script>

<style scoped lang="less">

</style>
